
























































import { Component, Vue } from 'vue-property-decorator';
import PageLoader from '@components/common/PageLoader.vue';
import Toast from '@common/helpers/toast';

@Component({
  components: {
    PageLoader,
  },
})
export default class PopupCopyResult extends Vue {
  public isLoading: boolean = false;
  public modalMessage: string = '';
  public copiedSuccessItems: any[] = [];
  public copiedFailedItems: any[] = [];

  handleBeforeOpen(event: any) {
    const params = event.params || {};
    const type = params.type || 'menu';
    this.copiedSuccessItems = params.success || [];
    this.copiedFailedItems = params.failed || [];
    if (type === 'menu') {
      this.modalMessage = '複製に失敗した診療サービスを再複製しましすか？';
    } else {
      this.modalMessage = '複製に失敗したプランを再複製しましすか？';
    }
  }

  cancel() {
    this.$modal.hide('popup-copy-result');
  }

  async retry() {
    if (!this.copiedFailedItems.length) {
      return;
    }

    try {
      this.isLoading = true;
      this.$emit('retry', this.copiedFailedItems);
      this.$modal.hide('popup-copy-result');
    } catch (e) {
      Toast.error('再実行に失敗しました。');
    } finally {
      this.isLoading = false;
    }
  }
}
